import { createPostRequest } from '../../../../helpers/request/request.js';
import { API_URLS } from '../../../../configs/constants/urls.js';
import { appendXsrfToken } from '../../../../helpers/request/utils.js';
import TokenService from '../../../../helpers/request/tokens.js';
export const generateLinkRequest = async (postData) => {
    try {
        if ((await TokenService.getCsrfToken()) !== true) {
            return { success: false };
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.SEND_PASSWORDLESS_LINK, postData, requestOptions);
        // await modifyUtagDataAfterLoginsAndRegistrations();
        if (response.data.success) {
            return { success: true };
        }
        /*
        except of success we can return:
        400: for non-existing email
        401: for invalid email
        500: for server error
        */
        return {
            success: false,
        };
    }
    catch (error) {
        return {
            success: false,
            status: error.response?.status || 500,
        };
    }
};
//# sourceMappingURL=generateLink.js.map